// extracted by mini-css-extract-plugin
export default {"bell-wrapper":"Yukkv","bell":"OzfkL"};